import {renderElement} from "./utils/common";

const getTooltipTemplate = () => `<span class="copy__hint js-copy-hint">Cкопировано</span>`;

export const copyToClipboard = () => {
  const copyItemElements = document.querySelectorAll(".js-copy");

  if (copyItemElements.length) {
    copyItemElements.forEach((copyItemElement) => {
      function copyTextElement() {
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(copyItemElement.dataset.copy.trim())
            .then(() => {
              showTooltip();
            })
            .catch((err) => {
              console.log("Something went wrong", err);
            });
        } else {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(copyItemElement);
          selection.removeAllRanges();
          selection.addRange(range);

          try {
            document.execCommand("copy");
            selection.removeAllRanges();

            showTooltip();
          } catch (error) {
            console.log("Something went wrong", error);
          }
        }
      }

      function onCopyElementClick() {
        copyTextElement();
      }

      function showTooltip() {
        renderElement(copyItemElement, getTooltipTemplate());

        setTimeout(() => copyItemElement.querySelector(`.js-copy-hint`).remove(), 3000);
      }

      copyItemElement.addEventListener("click", onCopyElementClick);
    });
  }
};
